module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/VacationsBookingFormSlim.module.scss");